import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WELCOME_IMAGE, scrollToId } from "@/lib/site";

export default function Welcome() {
  return (
    <section className="relative py-20 md:py-28" data-testid="welcome-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <Reveal>
            <Eyebrow>Welcome</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
              Welcome to <span className="text-brand">Motion Mind Institute</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 text-base text-gray-400 leading-relaxed">
              Motion Mind Institute is a creative learning institute for students and aspiring professionals
              who want to learn practical skills in Graphic Design, Photoshop and Video Editing.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="mt-4 text-base text-gray-400 leading-relaxed">
              Our goal is simple — help you learn the tools, practice your skills, create real projects and
              build the confidence to move toward a creative career.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <button
              onClick={() => scrollToId("#about")}
              className="group mt-8 inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-6 py-3.5 text-sm font-medium text-amber-400 hover:bg-amber-500 hover:text-obsidian hover:-translate-y-0.5 transition-all duration-300"
              data-testid="welcome-learn-more-button"
            >
              Learn More About Us
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15} y={36}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-amber-500/20 via-transparent to-transparent blur-2xl" />
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img
                src={WELCOME_IMAGE}
                alt="Student practicing creative design skills at a professional workstation"
                className="h-72 sm:h-96 w-full object-cover transition-transform duration-700 hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" />
              <motion.div
                className="absolute bottom-5 left-5 right-5 flex items-center justify-between rounded-2xl glass px-5 py-4"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ delay: 0.4, duration: 0.7 }}
              >
                <span className="font-display text-sm font-semibold text-white">Learn. Create. Grow.</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-500">
                  Since Day One, Hands-On
                </span>
              </motion.div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
